"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeCell = exports.newsBlock = exports.emptyCell = exports.attributionCell = void 0;

var _util = require("../../../util");

const attributionCell = () => ({
  width: '10%',
  whiteSpace: 'nowrap'
});

exports.attributionCell = attributionCell;

const emptyCell = () => ({
  width: 8
});

exports.emptyCell = emptyCell;

const newsBlock = ({
  theme
}) => ({
  transition: 'background 0.2s ease',
  cursor: 'pointer',
  boxShadow: (0, _util.boxShadow)(theme, [0, -1, 0, 'ui1', true]),
  ':hover': {
    background: (0, _util.color)(theme, 'interactive.row.hover')
  }
});

exports.newsBlock = newsBlock;

const timeCell = () => ({
  width: '5%'
});

exports.timeCell = timeCell;
//# sourceMappingURL=NewsTable.style.js.map